// extracted by mini-css-extract-plugin
export var completionBody = "_kg-2";
export var completionCard = "_kg-0";
export var completionFooter = "_kg-3";
export var completionTitle = "_kg-1";